import { createSlice, createAction, createEntityAdapter } from "@reduxjs/toolkit";

//Generators
export const generateSegmentValidationAction = createAction("validationResult/generateSegmentValidation");
const validationAdapter = createEntityAdapter({
  selectId: (segment) => segment.targetId,
});

const validateSlice = createSlice({
  name: "validation",
  initialState: validationAdapter.getInitialState({
    loading: false,
  }),
  reducers: {
    validationIsLoading: (state) => {
      state.loading = true;
    },
    segmentAdded: validationAdapter.addOne,
    validationLoading(state) {
      if (state.loading === false) {
        state.loading = true;
      }
    },
    validateSegment: (state, action) => {
      if (state.loading === true) {
        let result = action.payload.svr;
        result.targetId = action.payload.segmentId;
        let ifExists = state.ids.filter((id) => id == action.payload.segmentId);
        if (ifExists.length > 0) {
          validationAdapter.setOne(state, result);
        } else {
          validationAdapter.addOne(state, result);
        }
        state.loading = false;
      }
    },
    updateValidation: validationAdapter.updateOne,
  },
});
export const svrSelector = validationAdapter.getSelectors((state) => state.validation);
export const { validateSegment, segmentAdded, validationLoading, validationIsLoading } = validateSlice.actions;

export default validateSlice.reducer;
